module.exports = __webpack_public_path__ + "assets/img/title-d6cfb2ab.png";